export default {
    mapGeofenceDeleteGeofenceGroup_title:'Eliminar Grupos de Geocercas',
    mapGeofenceDeleteGeofenceGroup_move: 'Mover a',
    mapGeofenceDeleteGeofenceGroup_deleteAll: 'Eliminar (Todos las Geocercas en estos grupos serán borrados)',
    mapGeofenceDeleteGeofenceGroup_success: "Grupos de Geocercas eliminados",
    mapGeofenceDeleteGeofenceGroup_question1: '¿Que desea hacer con los Geocercas que pertenecen a estos grupos?',
    mapGeofenceDeleteGeofenceGroup_deleteAction: 'Acciones diponibles',
    mapGeofenceDeleteGeofenceGroup_question2: '¿Está seguro que desea eliminar estos grupos de Geocercas?',
    mapGeofenceDeleteGeofenceGroup_warning: 'Está acción no se puede deshacer',
}